import { getConfigValue } from "../Providers/ConfigsApi";

export default async function LoginTimeoutMinutes() {
  const configKey = 'login-timeout-minutes';
  const msecPerMin = 60000;
  const defaultMins = 180; // set default to 3hrs 

  try {
    let duration = await getConfigValue(configKey);
    duration = duration ? parseInt(duration) : defaultMins;
    return duration * msecPerMin;
  } catch (err) {
    return defaultMins * msecPerMin;
  }
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/LoginTimeoutMinutes.js